import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import SubscriptionGraph from "../../components/common/Graph";
import { GetCustomerInformationModel } from "../../services/Customer/CustomerApi";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import { GetQueryList } from "../../services/CustomerQuaries/CUstomerQuariesApi";
import { FaClipboardCheck } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import NoResultFoundModel from "../../components/common/NoDataFound";
import PaginationComponent from "../../components/common/PaginationModal";

const tabs = [
  { id: 1, label: "Customer View Details" },
  // { id: 2, label: "Subscriptions Package Details" },
  // { id: 3, label: "Usage" },
  { id: 4, label: "Feedback & Queries" },
];

function CustomerDetaills() {
  const navigate = useNavigate();
  const location = useLocation();
  const RoleTypeModuleName = "Predefined";
  console.log("Location State:", location.state);
  const { customerKeyID, Action } = location.state || {};
  console.log("customerKeyID:", customerKeyID);
  const { authDetails, pageSize } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);

  const [activeTab, setActiveTab] = useState(1);
  const [clientDetails, setClientDetails] = useState({});

  const histogramData = [
    {
      month: "Jan",
      completedJobs: 30,
      pendingJobs: 15,
      completedTasks: 40,
      pendingTasks: 10,
      totalClients: 25,
    },
    {
      month: "Feb",
      completedJobs: 50,
      pendingJobs: 20,
      completedTasks: 60,
      pendingTasks: 15,
      totalClients: 40,
    },
  ];

  const counterData = [
    { label: "Visitors", count: 1200, color: "text-blue-600" },
    { label: "Campaigns", count: 15, color: "text-green-600" },
    { label: "Leaves", count: 8, color: "text-red-600" },
    { label: "Documents Uploaded", count: 220, color: "text-purple-600" },
  ];

  const storageData = {
    percentage: 75,
    used: 150,
    total: 200,
  };

  const [modelRequestData, setModelRequestData] = useState({
    KeyID: null,
    Action: null,
    status: null,
    Name: null,
    remark: null,
  });

  //Customer Quaries
  const [quariesTypeSearch, setquariesTypeSearch] = useState("");
  const [LeaveTypeList, setLeaveTypeList] = useState([]);
  const [LeaveTypeListCount, setLeaveTypeListCount] = useState(0);
  const [quariesTypeCurrentPage, setquariesTypeCurrentPage] = useState(1);
  const [isLeaveTypeOpen, setLeaveTypeModalOpen] = useState(false);
  const [queryList, setQueryList] = useState([]);
  const [queryTypeListCount, setQueryTypeListCount] = useState(-1);
  const [isCompletedQueries, setIsCompletedQueries] = useState(false);
  const handleCloseSolveQuaryModal = () => setSolveQuaryModalOpen(false);
  const handleCloseViewQuaryModal = () => setViewQuaryModalOpen(false);

  //demo
  const [activeSubTab, setActiveSubTab] = useState("pendingQueries");
  const handleOpenSolveQuaryModal = () => setSolveQuaryModalOpen(true);
  const [isSolvequary, setSolveQuaryModalOpen] = useState(false);
  const [isViewquary, setViewQuaryModalOpen] = useState(false);

  const handleOpenViewQuaryModal = () => setViewQuaryModalOpen(true);

  const [subscriptionList, setSubscriptionList] = useState([]);

  useEffect(() => {
    fetch("/api/subscriptions") // Replace with your actual API endpoint
      .then((response) => response.json())
      .then((data) => setSubscriptionList(data))
      .catch((error) => console.error("Error fetching subscriptions:", error));
  }, []);

  const [selectedPlan, setSelectedPlan] = useState(null);

  useEffect(() => {
    if (activeTab === 1) {
      GetCustomerDetailsData(1);
    } else if (activeTab === 4) {
      GetQueryListData(1);
    }
  }, [activeTab]);

  const GetCustomerDetailsData = async () => {
    try {
      let response = await GetCustomerInformationModel(
        authDetails.adminKeyID,
        customerKeyID
      );

      if (response?.statusCode === 200) {
        setClientDetails(response.responseData.data); // Set the client details
      } else {
        console.warn("Unexpected API response structure", response);
      }
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };

  //Customer Quaries Api
  const GetQueryListData = async (i, searchKeyword, isCompleted) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetQueryList({
        moduleName: RoleTypeModuleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? quariesTypeSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
        IsCompleted: isCompleted ? "True" : "False", // Pass the IsCompleted parameter
        customerKeyID: location.state.customerKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setQueryList(list); // Update state with fetched data
        setQueryTypeListCount(response.totalCount);
      } else {
        setLoader(false);
        // Handle error response
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      // Optionally show an error message to the user
    }
  };

  const handleOpenPendingQueries = () => {
    setActiveSubTab("pendingQueries");
    GetQueryListData(1, null, false); // Fetch pending queries
    setIsCompletedQueries(false);
  };

  const handleOpenCompletedQueries = () => {
    setActiveSubTab("completedQueries");
    GetQueryListData(1, null, true); // Fetch completed queries
    setIsCompletedQueries(true);
  };

  const handleSearchFunction = (searchValue) => {
    if (activeTab === 4) {
      setquariesTypeSearch(searchValue);
      GetQueryListData(1, searchValue);
    }
  };

  const HandlePageChange = async (pageNumber) => {
    if (activeTab === 4) {
      setquariesTypeCurrentPage(pageNumber);
      await GetQueryListData(pageNumber); // Call your function with the selected page number
    }
  };

  return (
    <div className="p-4 max-w-full">
      {/* Tabs */}
      <div className="flex flex-wrap border-b border-gray-300 pb-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-5 py-2 text-sm font-medium transition-all relative ${
              activeTab === tab.id
                ? "text-[#135EA0] after:content-[''] after:block after:w-full after:h-[2px] after:bg-[#135EA0] after:absolute after:bottom-0 after:left-0"
                : "text-gray-600 hover:text-blue-500"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="mt-4 p-4 border rounded-lg bg-white shadow w-full overflow-x-auto">
        <p className="text-gray-700 font-semibold flex">
          <span className="mr-6">Customer Name: </span>{" "}
          <h6 className=" text-[#135EA0] ">{clientDetails.companyName}</h6>
        </p>
        {activeTab === 1 && (
          <div className="bg-gray-50 mx-auto w-full p-2">
            {/* Grid for Cards - 2 Cards per Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {/* Customer Information Card */}
              <div className="bg-white shadow rounded-lg p-3 border border-gray-200">
                <h3 className="text-md font-semibold text-[#135EA0] mb-2">
                  Customer Information
                </h3>
                <div className="space-y-1 text-gray-700 text-sm">
                  <p>
                    <strong>Customer ID:</strong> {clientDetails.customerCode}
                  </p>

                  <p>
                    <strong>Industry Type:</strong>{" "}
                    {clientDetails.customerIndustryName}
                  </p>
                  <p>
                    <strong>Account Manager:</strong>{" "}
                    {clientDetails.accountManager}
                  </p>
                  <p>
                    <strong>Subscription Type:</strong>{" "}
                    {clientDetails.subscriptionType}
                  </p>
                  <p>
                    <strong>Subscription Date:</strong>{" "}
                    {new Date(
                      clientDetails.subscriptionDdate
                    ).toLocaleDateString()}
                  </p>
                  <p>
                    <strong>Renewal Date:</strong>{" "}
                    {new Date(clientDetails.renewalDate).toLocaleDateString()}
                  </p>
                </div>
              </div>

              {/* Company Information Card */}
              <div className="bg-white shadow rounded-lg p-3 border border-gray-200">
                <h3 className="text-md font-semibold text-[#135EA0] mb-2">
                  Company Information
                </h3>
                <div className="space-y-1 text-gray-700 text-sm">
                  <p>
                    <strong>Company Name:</strong> {clientDetails.companyName}
                  </p>
                  <p>
                    <strong>Industry:</strong> {clientDetails.businessTypeName}
                  </p>
                  <p>
                    <strong>Location:</strong> {clientDetails.companyAddress}
                  </p>

                  <p>
                    <strong>Employees:</strong> {clientDetails.employees}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeTab === 2 && (
          <div className="bg-gray-50 mx-auto w-full p-4">
            {/* Flex container to display Card & Table side by side */}
            <div className="flex flex-col md:flex-row gap-4">
              {/* Subscription Details Card (Left Side) */}
              <div className="bg-white shadow rounded-lg p-6 border border-gray-200 w-full md:w-1/3">
                <h3 className="text-lg font-semibold text-center text-gray-700">
                  Subscription Details
                </h3>
                <p className="text-center text-gray-500 text-base">
                  ₹499/Month
                </p>

                <ul className="list-none text-gray-600 mt-2 space-y-1">
                  {[
                    { text: "Access to all features", icon: "✔" },
                    { text: "Priority support", icon: "✔" },
                    { text: "100GB storage", icon: "❌" },
                    { text: "Total Users: 5", icon: "✔" },
                    { text: "Total Customers: 10", icon: "❌" },
                    { text: "Timesheet Access: Unlimited", icon: "✔" },
                    { text: "Document Storage: 50GB", icon: "✔" },
                  ].map((item, index) => (
                    <li
                      key={index}
                      className="flex items-center space-x-2 text-sm"
                    >
                      <span
                        className={`text-lg ${
                          item.icon === "✔" ? "text-green-500" : "text-red-500"
                        }`}
                      >
                        {item.icon}
                      </span>
                      <span>{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Subscription Package Details Table (Right Side) */}
              <div className="bg-white shadow rounded-lg flex flex-col w-full md:w-2/3">
                {/* Header Section */}
                <div className="border-b p-4 flex justify-between items-center">
                  <h2 className="text-md font-semibold text-[#135EA0]">
                    Subscription Package Details
                  </h2>
                </div>

                <div className="flex flex-col table_wrapper border border-gray-200">
                  <div className="flex-1 overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-200 text-xs table-auto m-2">
                      <thead>
                        <tr className="sticky top-0 bg-white z-10">
                          {[
                            "Subscriptions Packages Name",
                            "Monthly Price",
                            "Yearly Price",
                            "Subscription Date",
                            "Renewal Date",
                            "Status",
                          ].map((header) => (
                            <th
                              key={header}
                              className="p-2 border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap text-sm"
                            >
                              {header}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {/* Dynamic Table Rows */}
                        {Array(1)
                          .fill(null)
                          .map((_, index) => (
                            <tr
                              key={index}
                              className="hover:bg-slate-50 border-b border-slate-200 text-center"
                            >
                              <td className="p-2 whitespace-nowrap text-left pl-2 text-sm">
                                Premium Package
                              </td>
                              <td className="p-2 whitespace-nowrap text-left pl-2 text-sm">
                                ₹ 499/-
                              </td>
                              <td className="p-2 whitespace-nowrap text-left pl-2 text-sm">
                                ₹ 4999/-
                              </td>
                              <td className="p-2 whitespace-nowrap text-left pl-2 text-sm">
                                3/2/2025
                              </td>
                              <td className="p-2 whitespace-nowrap text-left pl-2 text-sm">
                                3/4/2026
                              </td>
                              <td className="p-2 whitespace-nowrap text-left pl-2 text-sm">
                                Active
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination */}
                  {/* <div className="flex justify-center sm:justify-end p-4">
            <Pagination
              totalPages={2}
              currentPage={1}
              onPageChange={() => {}}
            />
          </div> */}
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 3 && (
          <SubscriptionGraph
            storageData={storageData}
            histogramData={histogramData}
            counterData={counterData}
          />
        )}
        {/* Customer Quaries */}
        {activeTab === 4 && (
          <div>
            <div className="flex border-b border-gray-300 pb-2">
              <button
                onClick={handleOpenPendingQueries}
                className={`px-3 py-2 text-xs font-small transition-all whitespace-nowrap ${
                  activeSubTab === "pendingQueries"
                    ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                    : "text-gray-600 hover:text-blue-500"
                }`}
              >
                Pending
              </button>
              <button
                onClick={handleOpenCompletedQueries}
                className={`px-3 py-2 text-xs font-small transition-all whitespace-nowrap ${
                  activeSubTab === "completedQueries"
                    ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                    : "text-gray-600 hover:text-blue-500"
                }`}
              >
                Completed
              </button>
            </div>

            {/* Search, Filter, and Export Section */}
            <div className="h-full bg-white shadow rounded-lg flex flex-col">
              <div className="p-2 border-b flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4">
                {/* Search Bar and Buttons Wrapper */}
                <div className="flex flex-wrap items-center gap-2 md:gap-4 ml-auto w-full md:w-auto justify-end">
                  {/* Export Button */}

                  {/* Filter Button */}
                  {/* <button className="flex items-center text-[#135EA0] hover:text-[#E86B1B] text-12">
                           <FaFilter className="mr-1" />
                           Filter
                         </button> */}

                  {/* Search Bar */}
                  <div className="relative flex items-center w-full md:w-64">
                    <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                    <input
                      type="text"
                      className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                      placeholder="Search..."
                      value={quariesTypeSearch}
                      onChange={(e) => {
                        handleSearchFunction(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Sub-Tab Content */}
            {activeSubTab === "pendingQueries" && (
              <div className="flex-1 overflow-y-auto">
                <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                  <thead>
                    <tr className="z-1 sticky top-0 bg-white">
                      <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                        Customer Name
                      </th>
                      <th className="p-2 border-b border-slate-200 text-left">
                        Query
                      </th>
                      <th className="p-2 border-b border-slate-200 text-left">
                        Received Date
                      </th>
                      <th className="p-2 border-b border-slate-200 text-right">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {queryList
                      .filter((query) => !query.completedOnDate) // Filter for pending queries
                      .map((query) => (
                        <tr
                          key={query.queryKeyID}
                          className="hover:bg-slate-50 border-b border-slate-200"
                        >
                          <td className="p-2">{query.createdByName}</td>
                          <td className="p-2">{query.query}</td>
                          <td className="p-2">
                            {new Date(query.createdOnDate).toLocaleDateString()}
                          </td>
                          <td className="whitespace-nowrap text-left p-1">
                            <div className="flex justify-end gap-2">
                              <Tooltip title="Solve Query" arrow>
                                <button
                                  onClick={() => {
                                    setModelRequestData({
                                      KeyID: query.queryKeyID,
                                      Action: "Update",
                                    });
                                    handleOpenSolveQuaryModal();
                                  }}
                                  className="text-[#135EA0] hover:text-[#135EA0]"
                                >
                                  <FaClipboardCheck className="text-sm" />
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {queryTypeListCount <= 0 && (
                  <NoResultFoundModel totalRecords={queryTypeListCount} />
                )}
              </div>
            )}

            {activeSubTab === "completedQueries" && (
              <div className="flex-1 overflow-y-auto">
                <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                  <thead>
                    <tr className="z-1 sticky top-0 bg-white">
                      <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                        Customer Name
                      </th>
                      <th className="p-2 border-b border-slate-200 text-left">
                        Query
                      </th>
                      <th className="p-2 border-b border-slate-200 text-left">
                        Received Date
                      </th>
                      <th className="p-2 border-b border-slate-200 text-left">
                        Completed Date
                      </th>
                      <th className="p-2 border-b border-slate-200 text-right">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {queryList
                      .filter((query) => query.completedOnDate) // Filter for completed queries
                      .map((query) => (
                        <tr
                          key={query.queryKeyID}
                          className="hover:bg-slate-50 border-b border-slate-200"
                        >
                          <td className="p-2">{query.createdByName}</td>
                          <td className="p-2">{query.query}</td>
                          <td className="p-2">
                            {new Date(query.createdOnDate).toLocaleDateString()}
                          </td>
                          <td className="p-2">
                            {query.completedOnDate
                              ? new Date(
                                  query.completedOnDate
                                ).toLocaleDateString()
                              : "-"}
                          </td>
                          <td className="whitespace-nowrap text-left p-1">
                            <div className="flex justify-end gap-2">
                              <Tooltip title="View Query Details" arrow>
                                <button
                                  onClick={() => {
                                    setModelRequestData({
                                      KeyID: query.queryKeyID,
                                      Action: "Update",
                                      remark: query.remark,
                                    });
                                    handleOpenViewQuaryModal();
                                  }}
                                  className="text-[#135EA0] hover:text-[#135EA0]"
                                >
                                  <FaEye className="text-sm" />
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {queryTypeListCount <= 0 && (
                  <NoResultFoundModel totalRecords={queryTypeListCount} />
                )}
              </div>
            )}
            {queryTypeListCount > pageSize && (
              <div className="flex justify-end ">
                <PaginationComponent
                  totalPages={Math.ceil(queryTypeListCount / pageSize)}
                  currentPage={quariesTypeCurrentPage}
                  onPageChange={HandlePageChange}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomerDetaills;
